/**
 * 配置服务
 * 获取后端配置信息并缓存
 */

let configCache = null
let configPromise = null

/**
 * 获取系统配置信息
 * @returns {Promise<Object>} 配置对象
 */
export const getConfig = async () => {
  // 如果有缓存，直接返回
  if (configCache) {
    return configCache
  }

  // 如果正在请求中，等待已有的请求
  if (configPromise) {
    return await configPromise
  }

  // 创建新的配置请求
  configPromise = fetchConfig()
  
  try {
    configCache = await configPromise
    return configCache
  } catch (error) {
    // 请求失败时清除promise，允许重试
    configPromise = null
    throw error
  }
}

/**
 * 获取API基础URL
 * @returns {Promise<string>} API基础URL
 */
export const getApiBaseUrl = async () => {
  try {
    const config = await getConfig()
    return config.api_base_url
  } catch (error) {
    console.warn('获取API配置失败，使用默认配置:', error)
    // 降级到默认配置
    if (import.meta.env.DEV) {
      return 'http://localhost:8000'
    } else {
      return window.location.origin
    }
  }
}

/**
 * 同步获取API基础URL（使用缓存）
 * 如果没有缓存，返回默认值
 * @returns {string} API基础URL
 */
export const getApiBaseUrlSync = () => {
  if (configCache) {
    return configCache.api_base_url
  }
  
  // 没有缓存时的默认值
  if (import.meta.env.DEV) {
    return 'http://localhost:8000'
  } else {
    return window.location.origin
  }
}

/**
 * 预加载配置信息
 * 在应用启动时调用，提前获取配置
 */
export const preloadConfig = () => {
  getConfig().catch(error => {
    console.warn('预加载配置失败:', error)
  })
}

/**
 * 清除配置缓存
 * 用于强制刷新配置
 */
export const clearConfigCache = () => {
  configCache = null
  configPromise = null
}

/**
 * 实际的网络请求
 * @returns {Promise<Object>}
 */
async function fetchConfig() {
  try {
    const response = await fetch('/emails/api/config/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include' // 包含认证信息
    })

    if (!response.ok) {
      throw new Error(`配置请求失败: ${response.status} ${response.statusText}`)
    }

    const config = await response.json()
    
    return config
  } catch (error) {
    console.error('获取系统配置失败:', error)
    throw error
  }
}

export default {
  getConfig,
  getApiBaseUrl,
  getApiBaseUrlSync,
  preloadConfig,
  clearConfigCache
}
